import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';
import './CreateOffer.css';

function EditOfferScope() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [introText, setIntroText] = useState('');

  useEffect(() => {
    fetchOffer();
  }, [id]);

  const fetchOffer = async () => {
    try {
      const response = await api.get(`/offers/${id}`);
      setIntroText(response.data.data.intro_text || '');
    } catch (error) {
      console.error('Teklif yüklenemedi:', error);
      alert('Teklif bulunamadı');
      navigate('/offers');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setLoading(true);
    try {
      await api.put(`/offers/${id}/scope`, { introText });
      alert('Kapsam başarıyla güncellendi!');
      navigate(`/offers/${id}`);
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'Kapsam güncellenemedi'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-offer-page">
      <div className="page-header">
        <h1>📝 Kapsam Düzenle</h1>
        <button className="btn-back" onClick={() => navigate(`/offers/${id}`)}>
          ← Geri
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h2>📋 Kapsam / Ön Yazı</h2>
          <p style={{color: '#666', fontSize: '14px', marginBottom: '15px'}}>
            Bu metin PDF'in ilk sayfasında "KAPSAM" başlığı altında görünecektir. 
            Boş bırakırsanız varsayılan metin kullanılacaktır.
          </p>
          
          <div className="form-group full-width">
            <label>Kapsam Metni</label>
            <textarea
              value={introText}
              onChange={(e) => setIntroText(e.target.value)}
              rows="15"
              placeholder="Sevgili [Müşteri Adı],

Saygılarımızla,
Mim Bytes"
              style={{fontSize: '14px', lineHeight: '1.8'}}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn-cancel" onClick={() => navigate(`/offers/${id}`)}>
            İptal
          </button>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Kaydediliyor...' : '✓ Kaydet'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditOfferScope;
